import moment from "moment";
import dayjs from "dayjs";
import { VENDOR_DETAILS } from "constants/general";
import { pushToDataLayer, setToStorage } from "core/utils/utils.helper";
import { CONTENT } from "constants/dataLayer";
import { utmFunctionsType } from "models/general";
import { EMOJI_DATA } from "constants/components";
//This function can be used to convert date from 21111986 to antd accepted date format
export const formattedDate = (inputDate: any) => {
  return moment(inputDate);
};

/**
 * @description  To covert the date in dayjs format which is acceptable in antd datepicker
 *
 */
export const formattedDateToPayload = (inputDate: any) => {
  if (inputDate !== "" || inputDate !== null) {
    const resDate = inputDate !== "" ? dayjs(inputDate).get("year") : null;
    return resDate;
  } else {
    return null;
  }
};

/**
 * @description check for utm parameters and do necessary actions
 *
 */
export const handleUtmFunctions = (
  searchParams: URLSearchParams | null,
  type?: utmFunctionsType,
) => {
  if (!searchParams) return;

  const utm_source = searchParams.get("utm_source") || "";
  const utm_type = searchParams.get("utm_parameter");
  const param = utm_source.toLowerCase().trim();
  const vendor = Object.values(VENDOR_DETAILS).includes(utm_source);

  // If type provided, behave accordingly. Otherwise, do both.

  if (!type || type === utmFunctionsType.NOTIFICATION) {
    if (utm_source && !vendor) {
      pushToDataLayer({
        ...CONTENT.NOTIFICATION,
        event_name: utm_source,
        button_name: utm_type,
      });
    }
  }

  if (!type || type === utmFunctionsType.REFERRER) {
    if (utm_source && vendor) {
      setToStorage("vendor", param);
    }
  }
};
//get emoji data based upon id
export function getEmojiById(id: number | undefined) {
  return EMOJI_DATA.find((item) => Number(item.id) === id);
}
